import {
  categories_tab,
  menus_tab,
  modifier_groups_tab,
  modifiers_tab,
  products_tab,
} from '../../../../../../views/menu/smart-pricing';
import { SMART_PRICING_RESOURCE_TYPE } from '../../../../../../services/exports/Constants';

export default {
  title: 'Prețuri inteligente',
  master_title: 'Mod brand - Prețuri inteligente',
  sections: {
    how_it_works: {
      title: 'Cum funcționează',
      description:
        'Prețurile inteligente sunt o funcție care vă permite să controlați prețurile în funcție de metodele de comandă utilizate de client. Aceasta acoperă mai multe scenarii, cum ar fi reducerea prețului pentru ridicare, creșterea prețului pentru livrare, adăugarea de reduceri pentru meniul sezonier etc. Puteți crea reguli pe mai multe niveluri (Global, Meniu, Categorie, Produs, Grup modificatori, Modificator). Nivelurile funcționează similar unui arbore, unde nivelul superior îl afectează pe cel inferior. Totodată, regula de la nivelul inferior are prioritate mai mare față de regula de la nivelul superior (ex.: regula de 5% reducere la ridicare pentru o Categorie specifică va suprascrie reducerea globală de 15% la ridicare pentru produsele sale).',
    },
  },
  tabs: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Reguli globale',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Reguli globale',
    [menus_tab]: 'Reguli meniu',
    [categories_tab]: 'Reguli categorie',
    [products_tab]: 'Reguli produs',
    [modifier_groups_tab]: 'Reguli grup modificatori',
    [modifiers_tab]: 'Reguli modificatori',
  },
  fields: {
    name: 'Nume',
    order_methods: 'Metode de comandă',
    modifier: 'Modificator',
    image: 'Imagine',
    actions: 'Acțiuni',
  },
  labels: {
    absolute: 'Absolut',
  },
  buttons: {
    add_rule: 'Adaugă regulă',
    edit: 'Editează',
    delete: 'Șterge ({{count}})',
    images: 'Gestionează imagine',
  },
  popups: {
    delete_rule: {
      title: 'Sigur doriți să ștergeți?',
    },
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
    failed_to_delete: 'Eroare la ștergerea regulilor',
    deleted_successfully: 'Regulile au fost șterse cu succes',
  },
};
